/**
 * Collection Annata Sort - Versione Semplificata e Robusta
 * Usa event delegation globale per evitare problemi con custom elements e handler duplicati
 */
(function() {
  'use strict';

  // Funzione per ordinare i prodotti
  function sortProductsByAnnata(direction) {
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) {
      console.warn('Collection Annata Sort: Product grid not found');
      return false;
    }

    const products = Array.from(productGrid.querySelectorAll('product-block'));
    
    if (products.length === 0) {
      console.warn('Collection Annata Sort: No products found');
      return false;
    }

    // Ordina prodotti per annata
    products.sort((a, b) => {
      const annataA = parseInt(a.dataset.annata) || 0;
      const annataB = parseInt(b.dataset.annata) || 0;
      
      if (direction === 'descending') {
        // Annata recente (higher year first)
        if (annataA === 0 && annataB !== 0) return 1;
        if (annataB === 0 && annataA !== 0) return -1;
        return annataB - annataA;
      } else {
        // Annata vecchia (lower year first)
        if (annataA === 0 && annataB !== 0) return 1;
        if (annataB === 0 && annataA !== 0) return -1;
        return annataA - annataB;
      }
    });

    // Riordina nel DOM
    products.forEach(product => {
      productGrid.appendChild(product);
    });
    
    return true;
  }

  // Aggiorna stato attivo
  function updateActiveState(sortValue, clickedLink) {
    // Aggiorna dropdown desktop
    document.querySelectorAll('[data-sort-annata]').forEach(link => {
      link.classList.remove('link-dropdown__link--active');
      const linkSortValue = link.dataset.sortAnnata === 'descending' ? 'annata-descending' : 'annata-ascending';
      if (linkSortValue === sortValue) {
        link.classList.add('link-dropdown__link--active');
      }
    });
    
    // Aggiorna il testo del bottone - cerca nel dropdown corretto
    if (clickedLink) {
      const dropdownEl = clickedLink.closest('link-dropdown');
      if (dropdownEl) {
        const buttonText = dropdownEl.querySelector('.link-dropdown__button-text');
        if (buttonText) {
          buttonText.textContent = clickedLink.textContent.trim();
          console.log('✅ Collection Annata Sort: Button text updated to', buttonText.textContent);
        } else {
          console.warn('⚠️ Collection Annata Sort: Button text element not found in dropdown');
        }
      } else {
        // Fallback: cerca in tutta la pagina
        const buttonText = document.querySelector('.link-dropdown__button-text');
        if (buttonText) {
          buttonText.textContent = clickedLink.textContent.trim();
        }
      }
    } else {
      // Se non c'è clickedLink, cerca il link attivo
      const activeLink = document.querySelector('[data-sort-annata].link-dropdown__link--active');
      if (activeLink) {
        const dropdownEl = activeLink.closest('link-dropdown');
        if (dropdownEl) {
          const buttonText = dropdownEl.querySelector('.link-dropdown__button-text');
          if (buttonText) {
            buttonText.textContent = activeLink.textContent.trim();
          }
        }
      }
    }

    // Aggiorna form mobile
    const mobileForm = document.querySelector('#CollectionFilterForm');
    if (mobileForm) {
      mobileForm.querySelectorAll('input[name="sort_by"]').forEach(input => {
        input.checked = input.value === sortValue;
        const label = input.closest('label');
        if (label) {
          mobileForm.querySelectorAll('label.filter-group__item').forEach(l => {
            l.classList.remove('filter-group__item--active');
          });
          if (input.checked) {
            label.classList.add('filter-group__item--active');
          }
        }
      });
    }
  }

  // Gestisce il click sui link annata
  function handleAnnataSortClick(evt) {
    const link = evt.target.closest('[data-sort-annata]');
    if (!link) return;

    const direction = link.dataset.sortAnnata;
    if (!direction) return;

    // Previeni comportamento di default e ferma propagazione IMMEDIATAMENTE
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    // Ordina prodotti
    const success = sortProductsByAnnata(direction);
    if (!success) return;

    const sortValue = direction === 'descending' ? 'annata-descending' : 'annata-ascending';
    updateActiveState(sortValue, link);

    // Chiudi dropdown
    const dropdownEl = link.closest('link-dropdown');
    if (dropdownEl) {
      const button = dropdownEl.querySelector('.link-dropdown__button');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    }

    // Aggiorna URL senza ricaricare
    const url = new URL(window.location);
    url.searchParams.set('sort_by', sortValue);
    window.history.pushState({}, '', url);
  }

  // Gestisce il cambio nel form mobile
  function handleMobileFormChange(evt) {
    const input = evt.target;
    if (input.name === 'sort_by' && (input.value === 'annata-descending' || input.value === 'annata-ascending')) {
      evt.preventDefault();
      evt.stopPropagation();
      
      const direction = input.dataset.sortAnnata || (input.value === 'annata-descending' ? 'descending' : 'ascending');
      sortProductsByAnnata(direction);
      
      // Trova il link corrispondente per aggiornare il testo del bottone
      const correspondingLink = document.querySelector(`[data-sort-annata="${direction === 'descending' ? 'descending' : 'ascending'}"]`);
      updateActiveState(input.value, correspondingLink);
      
      const url = new URL(window.location);
      url.searchParams.set('sort_by', input.value);
      window.history.pushState({}, '', url);
    }
  }

  // Inizializzazione
  function init() {
    // Event delegation globale per i click sui link annata
    // Usa capture phase (true) per eseguire PRIMA di altri handler
    document.addEventListener('click', handleAnnataSortClick, true);

    // Event delegation per il form mobile
    document.addEventListener('change', function(evt) {
      if (evt.target.closest('#CollectionFilterForm')) {
        handleMobileFormChange(evt);
      }
    }, true);

    // Gestisci ordinamento iniziale dall'URL
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    if (sortBy === 'annata-descending' || sortBy === 'annata-ascending') {
      const direction = sortBy === 'annata-descending' ? 'descending' : 'ascending';
      
      // Aspetta che i prodotti siano caricati
      const checkProducts = setInterval(() => {
        const products = document.querySelectorAll('product-block');
        if (products.length > 0) {
          clearInterval(checkProducts);
          sortProductsByAnnata(direction);
          // Trova il link corrispondente per aggiornare il testo
          const correspondingLink = document.querySelector(`[data-sort-annata="${direction}"]`);
          updateActiveState(sortBy, correspondingLink);
        }
      }, 100);
      
      setTimeout(() => clearInterval(checkProducts), 5000);
    }
  }

  // Avvia quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
